import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import { IClaimEntity } from '../../shared';
import { CreateClaimDto } from '../../dtos/claim.dto';
import { ICreateClaimEntity } from '../../entitites/claim.entity';

export class ClaimService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return this.getMany<IClaimEntity>(path, search, 'claims');
  }

  public async find(path: string) {
    return this.get<IClaimEntity>(path, 'claims');
  }

  public async create(
    customerGuid: string,
    args: ConstructorParameters<typeof CreateClaimDto>[number],
  ) {
    return await this.post<ICreateClaimEntity, CreateClaimDto>(
      `customers/${customerGuid}/claims/intake`,
      new CreateClaimDto(args),
      'Create claim',
    );
  }

  public async smartlink({ customerGuid }: { customerGuid: string }) {
    return await this.post<unknown, unknown>(
      `customers/${customerGuid}/claims/smartlink`,
      {},
      'Send smart claim link',
    );
  }
}
